import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'
import '../../src/util/install_sentry'

import './site_common'

import 'Components/refosumu/example_show/component'
import 'Components/refosumu/v2/floating/component'
import 'Components/refosumu/call_to_action_button/component'
import 'Components/refosumu/call_to_action_link/component'

import spToggleNav from '../../src/spToggleNav/spToggleNav'
$(() => {
  spToggleNav()
})
